import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { urlServices } from '../griviance/models/url.models';
import { encryptionService } from './cedService';
import { HttpServiceService } from './http-service.service';
import { ServerURLService } from './serverURL.service';


@Injectable({
  providedIn: 'root'
})
export class SignupService {
  constructor(public url: urlServices, public http: HttpServiceService, public ced: encryptionService, 
    public serverURL: ServerURLService, public router: Router, public toastr: ToastrService) { }
  
  getRandomKeyGenerator() {
    return this.http.get(this.url.getRandomKeyGenerator);
  }

  deleteOauthToken(){
    sessionStorage.setItem("deleteOauthToken","deleteOauthToken"); 
    if(sessionStorage.getItem('selectedRole-usec') == 'Student') {
      this.router.navigate(['/login/student']);
    } else {
      this.router.navigate(['/login']);
    }       
    this.toastr.error("Session has expired!!!", 'Error', {
      timeOut: 2000
    });
    const obj = {
      emailId: this.ced.encryptAesToString(sessionStorage.getItem('email-Id'), this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.deleteOauthToken, obj);
}

deleteOauthTokenLogout(){
  sessionStorage.setItem("deleteOauthToken","deleteOauthToken"); 
  if(sessionStorage.getItem('selectedRole-usec') == 'Student') {
    this.router.navigate(['/login/student']);
  } else {
    this.router.navigate(['/login']);
  }
  const obj = {
    emailId: this.ced.encryptAesToString(sessionStorage.getItem('email-Id'), this.serverURL.secretKey).toString(),
  } 
  return this.http.post(this.url.deleteOauthToken, obj);
}
  
  getRandomKeyGeneratorForWebsite() {
    return this.http.get(this.url.getRandomKeyGeneratorForWebsite);
  }
  
  login(obj) {
    return this.http.post(this.url.login, obj);
  }
  getLoginUserId() {
    return this.http.get(this.url.getLoginUserId);
  }
  getAccessTokenByRefreshToken(token) {
    return this.http.post(this.url.getAccessTokenByRefreshToken + '?refreshToken=' + token, '');
  }
  // checkCurrentPwd
  checkCurrentpwd(value){
    const obj = {
      password: this.ced.encryptAesToString(value, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.checkCurPwd, obj);
  }
  // changePassword
  changePassword(obj){
    return this.http.update(this.url.changePwd,obj);
  }

  // verify pwd status
  getPwdStatus(obj){
    return this.http.post(this.url.pwdStatus, obj);
  }
  updatePwdStatus(obj){
    return this.http.post(this.url.updatePwdStatus, obj);
  }

  getNotificationList(userId){
    return this.http.get(this.url.dakNotificationList +'?userId=' + userId);
  }

  getSuccessAuditLog(obj: any) {
    return this.http.post(this.url.getSuccessAuditLogData, obj);
  }

  getFailedAuditLog(obj: any) {
    return this.http.post(this.url.getFailedAuditLogData, obj);
  }

  setPwdUpdateFailedAuditLog() {
    return this.http.post(this.url.pwdUpdateFailedAuditLog, '');
  }

  // getSectionByRole
  getSectionByRole(roleName: any){
    const obj = {
      roleName: this.ced.encryptAesToString(roleName, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getSectionByRole, obj);
  }

  getLogoutAuditLog() {
    const obj = {
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString(),
      emailId: this.ced.encryptAesToString(sessionStorage.getItem('email-Id'), this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getLogoutAuditLog, obj);
  }

  getSessionTimeoutAuditLog() {
    const obj = {
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString(),
      emailId: this.ced.encryptAesToString(sessionStorage.getItem('email-Id'), this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.getSessionTimeoutAuditLog, obj);
  }

  changeRoleAuditLog() {
    const obj = {
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString(),
      emailId: this.ced.encryptAesToString(sessionStorage.getItem('email-Id'), this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.changeRoleAuditLog, obj);
  }

  getModuleURL(obj: any) {
    return this.http.post(this.url.getModuleURL, obj);
  }

  sendSMSTest(){
    return this.http.get(this.url.sendSMSTest);
  }

  sendMobileOTPTemplate(){
    return this.http.get(this.url.sendMobileOTPTemplate);
  }

  sendMobileOtpVerify(mobileNumber: string){
    return this.http.get(this.url.sendMobileOTP + '?mobileNumber=' + encodeURIComponent(this.ced.encryptAesToString(mobileNumber, this.serverURL.secretKey).toString()));
  }

  verifyOTPMobile(mobileNumber: string, otp: string){
    const obj= {
      mobileNumber: this.ced.encryptAesToString(mobileNumber, this.serverURL.secretKey).toString(),
      otp: this.ced.encryptAesToString(otp, this.serverURL.secretKey).toString(),
    }
    return this.http.post(this.url.verifyMobileOTP, obj);
  }

}
